import { Folder, FolderOpen, FolderSync, FileCode, File, FileText, FileJson, Braces, Code2, Shield } from 'lucide-react';
import { cn } from '../../lib/utils';
import {
  getFileIconType as getFileIconTypeFromMapping,
  type FileIconType as MappingFileIconType,
} from './fileIconMapping';

export type FileIconType = MappingFileIconType | 'folder';

interface FileIconProps {
  type: FileIconType;
  className?: string;
  isExpanded?: boolean;
  isLoading?: boolean;
}

const iconMap: Record<FileIconType, { icon: React.ElementType; color: string }> = {
  folder: { icon: Folder, color: 'text-blue-500' },
  apex: { icon: Code2, color: 'text-orange-500' },
  trigger: { icon: Code2, color: 'text-yellow-600' },
  visualforce: { icon: FileCode, color: 'text-purple-500' },
  lwc: { icon: Braces, color: 'text-yellow-500' },
  aura: { icon: Braces, color: 'text-red-500' },
  xml: { icon: FileText, color: 'text-orange-400' },
  json: { icon: FileJson, color: 'text-yellow-400' },
  css: { icon: FileCode, color: 'text-blue-400' },
  html: { icon: FileCode, color: 'text-red-400' },
  javascript: { icon: Braces, color: 'text-yellow-500' },
  certificate: { icon: Shield, color: 'text-green-600' },
  default: { icon: File, color: 'text-gray-500' },
};

export { getFileIconTypeFromMapping as getFileIconType };

export function FileIcon({ type, className, isExpanded, isLoading }: FileIconProps) {
  const { icon: Icon, color } = iconMap[type] || iconMap.default;
  const IconComponent =
    type === 'folder' && isLoading
      ? FolderSync
      : type === 'folder' && isExpanded
        ? FolderOpen
        : Icon;

  return (
    <IconComponent
      className={cn(
        'h-4 w-4 shrink-0 transition-transform',
        color,
        type === 'folder' && isExpanded && !isLoading && 'text-blue-400',
        type === 'folder' && isLoading,
        className
      )}
    />
  );
}
